import { render, staticRenderFns } from "./CandidateRequestView.vue?vue&type=template&id=2cfecb51&scoped=true"
import script from "./CandidateRequestView.vue?vue&type=script&lang=js"
export * from "./CandidateRequestView.vue?vue&type=script&lang=js"
import style0 from "./CandidateRequestView.vue?vue&type=style&index=0&id=2cfecb51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfecb51",
  null
  
)

export default component.exports